import React, { useContext, useEffect, useState } from 'react';

import dashboardServices from '../../services/hoa-dashboard-api-service';
import config from "../../hoa-config";
import { GlobalContext } from '../../context/hoa-global-context';
import datastore from '../../store/hoa-datastore';
import FilteringComponenet from "../filtering-component/hoa-filtering-comp";
import TableLayout from '../table-layout/hoa-table-layout';
import SuccessMessage from "../success-message/hoa-success-message";
import DocumentUploadModal from './document-upload-modal';

export default function DocumentsDashboard() {
    const { selectedValues, updateSelectedValues, document, updateDocumentData, view:views } = useContext<any>(GlobalContext);

    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [view, setView] = useState('list');
    const [uploadModalOpen, setUploadModalOpen] = useState(false)

    const headers = config.dashboard['Document']?.tableLayout?.title;
    const columns = config.dashboard['Document']?.tableLayout?.columns;
    const filteringTitle = config.dashboard['Document']?.filterComponent?.title;
    const filteringSubTitle = config.dashboard['Document']?.filterComponent?.subTitle;

    const handleDocumentLog = async (objectId: any, status: any) => {
        let logsData = {
          action: status,
          email: {},
          updatedBy: datastore.ownerInformation.email,
          documentId: objectId
        };
        await dashboardServices.createDocumentLog(logsData);
  };

    const getDocuments = async(numberOfDocuments: number, pageNo: number) => {
        const { data } = await dashboardServices.getDocuments(numberOfDocuments, pageNo, document.options, datastore.selectedOrganization?.id);
        return {
            data: data.documents,
            count: data.parseCount
        };
    }

    const updateDocument = async (objectId: string, newStatus: string) => {
        if(!objectId || !newStatus) {
            return;
        }

        let data = JSON.parse(JSON.stringify(document.data));
        let updateIndex = -1;
        data.find((value: any, index: number) => {
            if(value.objectId === objectId){
                updateIndex = index;
            }
        });
        
        if(updateIndex >= 0) {
            var updatedDocument = JSON.parse(JSON.stringify(data[updateIndex]));
            updatedDocument.status = newStatus;

            const result = await dashboardServices.updateDocument(updatedDocument);

            if(result.status == 200 && result.data) {
                data[updateIndex] = updatedDocument;
                updateDocumentData({
                    ...document,
                    data
                });
            }
        }
        handleDocumentLog(objectId, newStatus)
    }

    const downloadDocument = async (document: any) => {
        if(!document || !document.attachmentKey || !document.addedBy) {
            return;
        }

        let downloadKey = document.attachmentKey;
        let bucketName = '';

        if (document.addedBy === 'HPA') {
            bucketName = 'im-hoa-hpa';
        }
        else if (document.addedBy === 'Bridge Homes') {
            bucketName = 'im-bridge';
        }
        else {
            bucketName = 'im-hoa';
        }

        const isPdf = document.attachmentKey.includes('.pdf') ? true : false;

        const documentUrl = await dashboardServices.getSignedUrl(downloadKey, bucketName, isPdf);

        if(documentUrl && documentUrl.data) {
            window.open(String(documentUrl.data), '_blank');
        }
    }

    const toggleUploadModal = () => {
        setUploadModalOpen(!uploadModalOpen)
    }

    return (
        <>
            {
                view === 'list' ?
                <>
                    <FilteringComponenet
                        onAddClick={setView} 
                        title={filteringTitle} 
                        subTitle={filteringSubTitle} 
                        tagType={'Document'}
                        toggleUploadModal={toggleUploadModal}
                    />
                    <TableLayout
                        fetchResult={getDocuments}
                        headers={headers}
                        columns={columns}
                        tagType={"Document"}
                        updateView={setView} 
                        updateSelectedValues={updateSelectedValues}
                        updateDocument={updateDocument}
                        downloadDocument={downloadDocument}
                    />
                    <DocumentUploadModal 
                        uploadModalOpen={uploadModalOpen}
                        toggleUploadModal={toggleUploadModal}
                    />
                    <SuccessMessage
                        success={success}
                        setSuccess={setSuccess}
                        message={message}
                    />   
                </>
                :
                <></>   
            }
        </>
    )
}